import * as React from "react";
import { Trans } from "@lingui/react/macro";
import { AuthField } from "@app/ui/features/auth/AuthField";

export interface PasswordConfirmFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  /** 불일치 등 검증 실패 문구(이미 번역된 상태). 대조 자체는 shared/dto/auth 의
   * 스키마(v.forward)가 하고, 이 컴포넌트는 그 결과만 보여준다. */
  error?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const PasswordConfirmField = React.forwardRef<HTMLInputElement, PasswordConfirmFieldProps>(
  ({ id = "password-confirm", value, onChange, error, onBlur, required, disabled, className }, ref) => {
    return (
      <AuthField
        ref={ref}
        id={id}
        name="password-confirm"
        type="password"
        autoComplete="new-password"
        label={<Trans>비밀번호 확인</Trans>}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        required={required}
        disabled={disabled}
        className={className}
      />
    );
  }
);
PasswordConfirmField.displayName = "PasswordConfirmField";

export { PasswordConfirmField };
